import React, {Component} from "react";
import {Label,Form,Button,Col} from "reactstrap";
import {connect} from "react-redux";
import {Redirect} from 'react-router-dom';
import { FormGroup } from "semantic-ui-react";
import {GetProductFullVersion,GetDbVersion} from "../../../../action/Administration/administrationAction";

class SystemStatus extends Component{

    componentWillMount(){
        this.props.GetProductFullVersion();
        this.props.GetDbVersion();
    }

    constructor(props){
        super(props);
        this.state = {
            redirectback: false
        };
        this.BackToActionSettings = this.BackToActionSettings.bind(this);
    }

    BackToActionSettings(){
        this.setState({redirectback:true});
    }

    render(ProductFullVersion,DbVersion){
        if(this.state.redirectback){
            return <Redirect to={"/SystemAdmin/Administration"} />
        }
        let Fullversion = this.props.ProductFullVersion;
        console.log(Fullversion);
        let Dbversion = this.props.DbVersion;
        console.log( Dbversion );
        return(
            <div className="dbd_container">
                 <div className="bldng_installation_titlebar">
                    <div className="dbd_subheader" style={{"padding-left":"22px"}}>
                        <span className="PageTitleBar">{"System Status"}</span><br/><br/>
                        <Label className="ContentTextNoFloat" style={{paddingLeft:'2px'}}>{"This page shows the current server status."}</Label>
                    </div>
                 </div>
                 <div style={{paddingLeft:'15px', paddingTop:'50px'}}>
                     <Form>
                         <FormGroup row>
                                <Label className="ContentLabel">Product Version</Label>
                                <Label className="ContentTextNoFloat">{Fullversion}</Label>
                         </FormGroup>
                         <FormGroup row>
                                <Label className="ContentLabel">Database Version</Label>
                                <Label className="ContentTextNoFloat">{Dbversion}</Label>
                         </FormGroup>
                     </Form>
                 </div>
                 <FormGroup row className="btns_group">
                    <Col sm={{ size: 10 }} style={{"padding-left":"15px"}}>
                        <Button className="btn-gray btn-md" onClick={this.BackToActionSettings} > {"< BACK"} </Button>
                    </Col>
                </FormGroup>
            </div>
        );
    }
};

const mapStateToProps = state => {
    return{
        ProductFullVersion: state.InstallationsRootReducer.Productfullversion,
        DbVersion: state.InstallationsRootReducer.Dbversion
    };
}
const mapDispatchToProps = (dispatch)=>{
    return{
        GetProductFullVersion: () => dispatch(GetProductFullVersion()),
        GetDbVersion: () => dispatch(GetDbVersion())
    };
}
export default connect(mapStateToProps,mapDispatchToProps) (SystemStatus);
